import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { showAccessDeniedAlert } from "../../../utils/accessDenied"
import RoutesMap from "../../../route_control/RouteControl"
import axios from "axios"

export const stateByCountry = createAsyncThunk('stateByCountry', async ({ id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `state_by_country/${id}`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + localStorage.getItem('user_token'),
            }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const stateByCountrySlice = createSlice({
    name: 'stateByCountry',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(stateByCountry.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                localStorage.clear()
                action.meta.arg.navigate(RoutesMap.LOGIN.path)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(stateByCountry.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default stateByCountrySlice.reducer; 